import React from 'react';
import { withOneTabEnforcer } from "react-one-tab-enforcer";
import DuplicatedTabMessage from "./duplicated_tab_message";
import Instructions from "./exam_structure/instructions";
import Situation from "./exam_structure/situation";
import Question from "./exam_structure/question";
import Status from "./exam_structure/status";
import ExamFinished from "./exam_structure/exam_finished";
import TextField from "./exam_structure/text_field";
import {
    getInstructions,
    getQuestion,
    getResult,
    sendAnswer,
    updateSituationTimesShown,
    sendText
} from "../services/exams";

class ExamsContainer extends React.Component {
    constructor(props) {
        super(props);

        let { minutes, questions_answered, message, show_text_field } = props.details_exam;
        this.state = {
            firstRender: true,
            showInstructions: false,
            showSituation: false,
            showTextField: show_text_field,
            situationTimesShown: 0,
            maxTimesToShowSituationReading: 2,
            maxTimesToShowSituationHearing: 1,
            currentInstructions: null,
            currentSituation: null,
            currentQuestion: null,
            currentQuestionId: '',
            currentValue: 0,
            textValue: '',
            currentIddSection: null,
            totalAnswered: 0,
            minutes: minutes,
            globalTotalAnswered: questions_answered,
            showMessageContinuation: false,
            messageContinuation: message,
            finished: false,
            lastQuestion: false,
            disabledHearingButton: true,
            loadingNextQuestion: false,
            examResult: ''
        };

        this.answerChange = this.answerChange.bind(this);
        this.handleText = this.handleText.bind(this);
        this.requestTextField = this.requestTextField.bind(this);
        this.requestInstructions = this.requestInstructions.bind(this);
        this.requestQuestion = this.requestQuestion.bind(this);
        this.getNextQuestion = this.getNextQuestion.bind(this);
        this.requestSendAnswer = this.requestSendAnswer.bind(this);
        this.showSituationReading = this.showSituationReading.bind(this);
        this.showSituationHearing = this.showSituationHearing.bind(this);
        this.verifyIfReadingOrHearing = this.verifyIfReadingOrHearing.bind(this);
        this.verifyIfHearing = this.verifyIfHearing.bind(this);
        this.verifyIfReading = this.verifyIfReading.bind(this);
        this.enableOrDisableHearingButton = this.enableOrDisableHearingButton.bind(this);
        this.initTimer = this.initTimer.bind(this);
        this.disappearAlert = this.disappearAlert.bind(this);
        this.requestUpdateSituationState = this.requestUpdateSituationState.bind(this);
        this.getAudioForSituation = this.getAudioForSituation.bind(this);
        this.requestResult = this.requestResult.bind(this);
        this.finishExam = this.finishExam.bind(this);
    }

    componentDidMount() {
        let { totalAnswered, globalTotalAnswered } = this.state;
        let { sections, exam_finished, show_text_field } = this.props.details_exam;
        if (exam_finished) {
            !show_text_field && this.finishExam();
        } else {
            let { questions } = sections[0];
            this.setState({
                currentIddSection: sections[0].IddSeccion,
                currentQuestionId: questions[totalAnswered].IdPregunta,
                showMessageContinuation: (globalTotalAnswered > 0),
                situationTimesShown: questions[totalAnswered].situationTimesShown
            }, () => {
                totalAnswered === 0 && this.requestInstructions(sections[0].IdInstrucciones);
                this.requestQuestion();
                this.initTimer();
            });
        }

        $('#loading-exam').addClass('m--hide');
    }

    answerChange(event) {
        let value = parseInt(event.currentTarget.value);
        if (value === NaN) {
            value = 0;
        }

        this.setState({currentValue: value});
    }

    handleText(event) {
        let value = event.currentTarget.value;
        this.setState({textValue: value});
    }

    getNextQuestion() {
        let { sections, labels } = this.props.details_exam;
        let { RequiereWriting } = labels;
        let {
            currentIddSection,
            currentQuestionId,
            showInstructions,
            currentSituation,
            showSituation,
            situationTimesShown
        } = this.state;

        this.setState({showMessageContinuation: false});

        // Verifica si estaba mostrando instrucciones para no saltarse la primer pregunta de la sección
        if (showInstructions === true) {
            this.setState({showInstructions: false});

            // Si es situación de lectura muestra la situación
            if (this.verifyIfReading(currentSituation.TipoSituacion)) {
                this.setState({showSituation: true});
            }
        } else if (showSituation === true) {
            // Aquí no se toma en cuenta que se escucho el audio,
            // porque se toma en cuenta cuando da clic en botón Escuchar
            if (this.verifyIfReading(currentSituation.TipoSituacion)) {
                situationTimesShown += 1;
                // Actualiza times de situations_state en base de datos de postgres si es lectura
                this.requestUpdateSituationState();
            }
            this.setState({
                showSituation: false,
                situationTimesShown: situationTimesShown
            }, () => {
                let currentSection = sections.find(section => section.IddSeccion == currentIddSection);
                this.verifyIfLastQuestion(sections, currentSection, currentQuestionId);
                this.enableOrDisableHearingButton();
            });
        } else {
            let currentSection = sections.find(section => section.IddSeccion == currentIddSection);
            let { questions } = currentSection;
            // TODO: Descomentar para no poder modificar el número de preguntas contestadas
            // let questionFilter = questions.find(question => question.IdPregunta == currentQuestionId);
            // let totalAnswered = questions.indexOf(questionFilter) + 1;
            let totalAnswered = this.state.totalAnswered + 1;
            let globalTotalAnswered = this.state.globalTotalAnswered + 1;

            // Verifica si ya le mostro todas las preguntas de esa sección
            if (totalAnswered >= questions.length) {
                let nextSectionIndex = sections.indexOf(currentSection) + 1;

                // Verifica si ya no tiene secciones para dar por terminado el examen
                if (nextSectionIndex >= sections.length) {
                    if (RequiereWriting) {
                        this.setState({showTextField: true});
                        clearInterval(this.interval);
                    } else {
                        this.finishExam();
                    }
                } else {
                    // Muestra la siguiente sección comenzando por las instrucciones
                    currentSection = sections[nextSectionIndex];
                    totalAnswered = 0;

                    this.requestInstructions(currentSection.IdInstrucciones);
                }
            }

            this.setState({totalAnswered: totalAnswered, globalTotalAnswered: globalTotalAnswered});

            if (currentSection.questions.length > totalAnswered) {
                this.setState({
                    currentIddSection: currentSection.IddSeccion,
                    currentQuestionId: currentSection.questions[totalAnswered].IdPregunta,
                }, () => {
                    this.requestQuestion();
                });
            }
        }
    }

    requestInstructions(instructions_id) {
        let { firstRender, situationTimesShown } = this.state;
        getInstructions(instructions_id).then(response_instructions => {
            let { instructions } = response_instructions.data;

            if (firstRender) {
                this.setState({currentInstructions: instructions, showInstructions: (situationTimesShown == 0)});
            } else {
                this.setState({currentInstructions: instructions, showInstructions: true});
            }
        });
    }

    requestQuestion() {
        let { sections } = this.props.details_exam;
        let { firstRender, situationTimesShown, currentQuestionId, currentIddSection, currentSituation } = this.state;

        let currentSection = sections.find(section => section.IddSeccion == currentIddSection);

        getQuestion(currentQuestionId).then(response => {
            let { question } = response.data;

            this.setState({currentQuestion: question }, () => {
                let situation = currentSection.questions.find(q => q.IdPregunta === parseInt(question.question_id));

                this.setState({currentSituation: situation, loadingNextQuestion: false, currentValue: 0}, () => {
                    let situationId = (currentSituation === null ? 0 : currentSituation.IdSituacion);
                    let differentSituation = situation.IdSituacion !== situationId;

                    // Verifica si cambia la situación
                    if (differentSituation) {
                        if (this.verifyIfReadingOrHearing(situation.TipoSituacion)) {
                            let changes;
                            if (firstRender) {
                                // Muestra la situación si situationTimesShown es 0
                                changes = {showSituation: (situationTimesShown == 0), firstRender: false};
                            } else {
                                changes = {showSituation: true, situationTimesShown: 0};
                            }
                            this.setState(changes, () => {
                                // Verifica si muestra o no el botón de Escuchar
                                if (this.verifyIfHearing(situation.TipoSituacion)) {
                                    this.enableOrDisableHearingButton();
                                }
                            });
                        }
                    }
                });
            });
        });
    }

    requestSendAnswer() {
        let { presentation_id } = this.props.details_exam;
        let { showInstructions, showSituation, currentSituation, currentQuestion, currentValue, minutes,
            situationTimesShown } = this.state;
        this.setState({currentValue: 0, loadingNextQuestion: true}, () => {
            if (showInstructions === false && showSituation === false) {
                sendAnswer(
                    presentation_id, currentSituation.IddSeccion, currentQuestion.question_id, currentValue, minutes,
                    currentSituation.IdSituacion, situationTimesShown, currentSituation.TipoSituacion
                ).then(response => {
                    this.getNextQuestion();
                });
            }

        });
    }

    requestUpdateSituationState() {
        let { presentation_id } = this.props.details_exam;
        let { currentSituation } = this.state;

        updateSituationTimesShown(presentation_id, currentSituation.IdSituacion, currentSituation.TipoSituacion);
    }

    requestResult() {
        let { presentation_id, exam_id } = this.props.details_exam;
        getResult(presentation_id, exam_id).then(response => {
            this.setState({ examResult: response.data.result });
        });
    }

    finishExam() {
        this.setState({finished: true}, () => {
            this.requestResult();
        });
    }

    requestTextField() {
        let { presentation_id, key } = this.props.details_exam;
        let { textValue } = this.state;

        sendText(presentation_id, textValue, key).then(response => {
            this.setState({showTextField: false});
            this.finishExam();
        })
    }

    showSituationReading() { this.setState({lastQuestion: false, showSituation: true}); }

    showSituationHearing() {
        let { showSituation, situationTimesShown, maxTimesToShowSituationHearing } = this.state;
        let audio = document.getElementById("audio_player");

        // Se ajusta volumen de reproductor web al máximo
        audio.volume = 1.0;
        audio.play();

        let stateChanges = {situationTimesShown: (situationTimesShown + 1)};

        // Verifica si se está mostrando la situación
        // Si se esta mostrando habilita el botón de Escuchar
        if (showSituation) {
            stateChanges.disabledHearingButton = true;
        } else {
            // Verifica si ya se mostró el número máximo de veces que puede escuchar el audio
            stateChanges.disabledHearingButton = (situationTimesShown >= maxTimesToShowSituationHearing);
        }

        this.setState(stateChanges);
        this.requestUpdateSituationState();
    }

    enableOrDisableHearingButton() {
        let { currentSituation, showSituation, situationTimesShown, maxTimesToShowSituationHearing } = this.state;

        if (this.verifyIfHearing(currentSituation.TipoSituacion)) {
            let disabledHearingButton;
            if (showSituation) {
                disabledHearingButton = false;
            } else {
                disabledHearingButton = (situationTimesShown >= maxTimesToShowSituationHearing);
            }
            this.setState({disabledHearingButton: disabledHearingButton});
        }
    }

    verifyIfReadingOrHearing(tipoSituacion) {
        return [1, 2].indexOf(tipoSituacion) !== -1;
    }

    verifyIfHearing(tipoSituacion) {
        return tipoSituacion == 2;
    }

    verifyIfReading(tipoSituacion) {
        return tipoSituacion == 1;
    }

    // Verifica si es la última pregunta de la última seccion
    verifyIfLastQuestion(sections, currentSection, questionId) {
        let { showInstructions, showSituation } = this.state;
        let lastSection = sections[sections.length - 1];
        let numberOfQuestions = lastSection.questions.length;
        let lastQuestion = lastSection.questions[numberOfQuestions - 1];

        if (currentSection.IddSeccion === lastSection.IddSeccion
            && lastQuestion.IdPregunta === parseInt(questionId)
            && showInstructions === false && showSituation === false) {
            this.setState({lastQuestion: true});
        }
    }

    initTimer(){
        let { minutes } = this.state;
        let { Duracion, RequiereWriting } = this.props.details_exam.labels;
        
        this.interval = setInterval(() => {
            minutes += 1;
            this.setState({ minutes: minutes });
            if (minutes >= Duracion) {
                if (RequiereWriting) {
                    this.setState({showTextField: true});
                } else {
                    this.finishExam();
                }
                clearInterval(this.interval);
            }
        }, 60000);
    }

    disappearAlert() {
        this.setState({ showMessageContinuation: false });
    }

    getAudioForSituation() {
        let { sections } = this.props.details_exam;
        let { currentIddSection, currentSituation } = this.state;

        let currentSection = sections.find(section => section.IddSeccion == currentIddSection);

        if (currentSection.questions[currentSituation.audio_index]) {
            return currentSection.questions[currentSituation.audio_index].audio;
        } else {
            return '';
        }
    }

    render() {
        let {
            showInstructions,
            showTextField,
            currentInstructions,
            currentSituation,
            currentQuestion,
            currentValue,
            textValue,
            lastQuestion,
            finished,
            showSituation,
            situationTimesShown,
            maxTimesToShowSituationReading,
            maxTimesToShowSituationHearing,
            minutes,
            globalTotalAnswered,
            showMessageContinuation,
            messageContinuation,
            disabledHearingButton,
            loadingNextQuestion,
            examResult
        } = this.state;

        let { details_exam } = this.props;
        let { labels, exam_id } = details_exam;
        let { RequiereWriting } = labels;

        return (
            <div>
                { (finished === false || showTextField == true) &&
                <div>
                    { showMessageContinuation &&
                        <div className="m-alert m-alert--icon m-alert--air alert alert-success alert-dismissible fade show"
                            role="alert">
                            <div className="m-alert__icon">
                                <i className="la la-warning"></i>
                            </div>
                            <div className="m-alert__text">
                                <strong>{ messageContinuation }</strong>
                            </div>
                            <div className="m-alert__close">
                                <button type="button" className="close" onClick={this.disappearAlert}>
                                </button>
                            </div>
                        </div>
                    }
                    { showInstructions === true &&
                        <Instructions currentInstructions={currentInstructions} labels={labels}
                                      getNextQuestion={this.getNextQuestion} />
                    }
                    { (showTextField === false && showInstructions === false && currentQuestion !== null) &&
                        <div>
                            { (showSituation === true && currentSituation !== null) &&
                                <Situation currentSituation={currentSituation} labels={labels}
                                           situationTimesShown={situationTimesShown}
                                           disabledHearingButton={disabledHearingButton}
                                           verifyIfHearing={this.verifyIfHearing}
                                           verifyIfReading={this.verifyIfReading}
                                           showSituationHearing={this.showSituationHearing}
                                           getNextQuestion={this.getNextQuestion}
                                           getAudioForSituation={this.getAudioForSituation}
                                />
                            }
                            { showSituation === false && currentSituation !== null &&
                                <Question currentSituation={currentSituation} currentQuestion={currentQuestion}
                                          currentValue={currentValue} labels={labels}
                                          situationTimesShown={situationTimesShown} lastQuestion={lastQuestion}
                                          maxTimesToShowSituationReading={maxTimesToShowSituationReading}
                                          maxTimesToShowSituationHearing={maxTimesToShowSituationHearing}
                                          loadingNextQuestion={loadingNextQuestion}
                                          verifyIfReadingOrHearing={this.verifyIfReadingOrHearing}
                                          verifyIfReading={this.verifyIfReading}
                                          verifyIfHearing={this.verifyIfHearing}
                                          answerChange={this.answerChange} requestSendAnswer={this.requestSendAnswer}
                                          showSituationReading={this.showSituationReading}
                                          showSituationHearing={this.showSituationHearing}
                                          getAudioForSituation={this.getAudioForSituation}
                                           />
                            }
                        </div>
                    }
                    { showTextField === true && RequiereWriting === true &&
                        <TextField labels={labels} textValue={textValue} handleText={this.handleText}
                                   requestTextField={this.requestTextField} />
                    }
                    { showInstructions === false &&
                        <Status labels={labels} globalTotalAnswered={globalTotalAnswered} minutes={minutes} />
                    }
                </div>
                }
                { finished === true && showTextField == false &&
                    <ExamFinished examResult={examResult} exam_id={exam_id} /> }
            </div>
        );
    }
}

export default withOneTabEnforcer({appName: "admin_exams", OnlyOneTabComponent: DuplicatedTabMessage})(ExamsContainer);
